import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Map } from 'immutable'
import isNil from 'lodash/isNil'
import { getBoundActions } from '../../actions/index'
// import { TYPE_LIVE_ACCESS_EMAIL_CAPTURE } from '../../services/dialog/index'
import {
  H2,
  H3,
  H5,
  H6,
  HEADING_TYPES,
} from '../Heading/index'
// import _snakeCase from 'lodash/snakeCase'
// import { URL_GAIA_PLUS } from '../../services/url/constants'
import Icon, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'
// import { transformEventRoute } from '../../services/live-access-events/index'

// const ONEDAY = 1000 * 60 * 60 * 24

export const isEventCancelled = (startDate) => {
  return (new Date(startDate).getFullYear()) === 2000
}
export const stripYear = (dateString) => {
  const str = dateString.substring(0, dateString.lastIndexOf(' '))
  return str.split(',')[0]
}

/* const shouldSaleInfoRender = (isEventsPlusMember, onlyText) => {
  if (isEventsPlusMember && !onlyText) {
    return true
  }
  return !isEventsPlusMember && onlyText
}
*/
/* const shouldRemindMeButtonRender = (onlyText, showSaleInfo, isEventsPlusMember) => {
  if (!onlyText && showSaleInfo && !isEventsPlusMember) {
    return true
  }
  if (!onlyText && !showSaleInfo && !isEventsPlusMember) {
    return true
  }
  return !!(!onlyText && showSaleInfo && isEventsPlusMember)
} */

/* function addModal (
  saleInfo,
  id,
  remindMe,
  renderModal,
  email,
  staticText,
  speakerName,
  isEventsPlusMember,
  onlyText,
) {
  const showSaleInfo = shouldSaleInfoRender(isEventsPlusMember, onlyText)
  const showRemindMeButton = shouldRemindMeButtonRender(onlyText, showSaleInfo, isEventsPlusMember)

  return (
    <div className="event-item__sale-line">
      {showSaleInfo && <div>{saleInfo}</div>}

      {(showRemindMeButton)
        ? <div className="event-item__remind-me">
          <span
            className="event-item__status-inline"
            onClick={() => {
              renderModal(TYPE_LIVE_ACCESS_EMAIL_CAPTURE, {
                title: staticText.getIn(['data', 'ticketReminder']),
                email,
                id,
                speakerName,
              })
            }}
          >
            <svg className="event-item__remind-me-icon" />
            <span className="event-item__remind-me-text">{remindMe}</span>
          </span>
        </div>
        : ''}
    </div>
  )
} */

/* eslint-disable */
/* function ticketsOnSale (
  onSaleDate,
  language,
  ticketsAvailable,
  staticText,
  renderModal,
  id,
  email,
  onDemand,
  cancelled,
  speakerName = '',
  isEventsPlusMember = true,
  onlyModalText = false,
) {
  const nonBreakingSpace = '\u00a0'

  if (onDemand) {
    return (
      <span className="event-item__status-inline">
        <svg className="event-item__icon event-item__icon--on-demand" />
        {staticText.getIn(['data', 'onDemand']) || nonBreakingSpace}
      </span>
    )
  }

  if (cancelled) {
    return (<div className="event-item__sold-out">{staticText.getIn(['data', 'cancelled']) || nonBreakingSpace}</div>)
  }

  if (!ticketsAvailable) {
    return (<div className="event-item__sold-out">{staticText.getIn(['data', 'soldOut']) || nonBreakingSpace}</div>)
  }

  const remindMe = staticText.getIn(['data', 'remindMe'])
  let saleInfo = staticText.getIn(['data', 'moreInfoSoon'])
  if (!onSaleDate) {
    let SPEAKER_NAME_EVENT_FORM = speakerName
    if (speakerName.length > 0) {
      SPEAKER_NAME_EVENT_FORM = `${_snakeCase(speakerName).toUpperCase()}_EVENT_REMIND_ME_FORM`
    }
    return addModal(
      saleInfo,
      id,
      remindMe,
      renderModal,
      email,
      staticText,
      SPEAKER_NAME_EVENT_FORM,
      isEventsPlusMember,
      onlyModalText,
    )
  }

  const date = new Date(onSaleDate)
  if (Date.now() > date.getTime()) {
    return (
      <span className="event-item__status-inline">
        <svg className="event-item__icon event-item__icon--ticket" />
        {staticText.getIn(['data', 'onSaleNow']) || nonBreakingSpace}
      </span>
    )
  }

  const preSaleDate = new Date(date.getTime() - (7 * ONEDAY))
  const preSale = `${preSaleDate.toLocaleString(language, { month: 'long' })} ${preSaleDate.getDate()}`
  const sale = `${date.toLocaleString(language, { month: 'long' })} ${date.getDate()}`
  saleInfo = `${staticText.getIn(['data', 'preSale'])}: ${preSale} | ${staticText.getIn(['data', 'onSale'])}: ${sale}`

  return addModal(saleInfo, id, remindMe, renderModal, email, staticText, '', isEventsPlusMember)
} */

// const renderButton = (route, staticText, seriesUrl) => {
//   const enabled = !!(route || seriesUrl)
//   let moreInfo
//   if (route) {
//     moreInfo = route.startsWith('/') ? route : `${URL_GAIA_PLUS}/${route}`
//     moreInfo = transformEventRoute(moreInfo)
//   }

//   const text = (seriesUrl && staticText.getIn(['data', 'watchNow']))
//     || (moreInfo && staticText.getIn(['data', 'moreInfo']))
//     || staticText.getIn(['data', 'comingSoon'])
//   return enabled
//     ? <Button
//       type={TYPES.PRIMARY}
//       url={seriesUrl || moreInfo}
//       scrollToTop
//     >
//       {text}
//     </Button>
//     : <Button
//       disabled
//     >
//       {text}
//     </Button>
// }

/* eslint-enable */
function EventItem ({
  details,
  // language,
  // staticText,
  // renderModal,
  // email,
  isActive,
  // isEventsPlusMember,
  fixWidth,
}) {
  const {
    descriptionShort,
    // route,
    eventThumbnailUrl,
    // ticketSaleDate,
    // ticketsAvailable,
    // id,
    // routeEnabled,
    // seriesUrl,
    localeTitleDate,
    titleShort,
    speakerNames,
    startDate,
  } = details.toJS()
  const cancelled = isEventCancelled(startDate)
  const dateString = cancelled ? stripYear(localeTitleDate) : localeTitleDate
  const nonBreakingSpace = '\u00a0'

  // const onlyModalText = !isEventsPlusMember
  return (
    <div className={`event-item ${isActive ? 'event-item--active' : ''} ${fixWidth || ''}`.trim()}>
      <img
        className="event-item__thumbnail"
        src={eventThumbnailUrl || ''}
        alt={speakerNames[0] || ''}
      />
      <div className="event-item__title-speaker">
        {titleShort && <H3 className="event-item__title">{titleShort}</H3>}
        <H5 className="event-item__speaker">
          {(speakerNames.length === 1 && speakerNames[0])
            ? speakerNames[0]
            : nonBreakingSpace}
        </H5>
      </div>
      {/* <div className="event-item__saleText">
        {ticketsOnSale(
          ticketSaleDate,
          language,
          ticketsAvailable,
          staticText,
          renderModal,
          id,
          email,
          !!seriesUrl,
          cancelled,
          speakerNames[0],
          isEventsPlusMember,
          onlyModalText,
        )}
      </div> */}
      <div className="event-item__long-description">
        {descriptionShort || nonBreakingSpace}
      </div>
      <H6 className="event-item__dates">{dateString || nonBreakingSpace}</H6>
      <div className="event-item__cta">
        {/* {renderButton(routeEnabled && route, staticText, seriesUrl)} */}
        {/* {!isEventsPlusMember && ticketsOnSale(
          ticketSaleDate,
          language,
          ticketsAvailable,
          staticText,
          renderModal,
          id,
          email,
          !!seriesUrl,
          cancelled,
          speakerNames[0],
          isEventsPlusMember,
          false,
        )} */}
      </div>
    </div>
  )
}

const TABLET_BREAKPOINT = 944
const DESKTOP_BREAKPOINT = 1444

function getVisibleCount () {
  if (typeof global === 'undefined') {
    return 3
  }

  const { innerWidth } = global
  if (innerWidth < TABLET_BREAKPOINT) {
    return 1
  }

  if (innerWidth < DESKTOP_BREAKPOINT) {
    return 2
  }

  return 3
}

const EventsAMAList = ({
  eventsList,
  language,
  email,
  isEventsPlusMember,
}) => {
  const dispatch = useDispatch()
  const staticText = useSelector((state) => state.staticText.getIn(['data', 'eventsAMAPage'], Map()))
  const renderModal = useMemo(() => getBoundActions(dispatch).dialog.renderModal, [dispatch])

  const length = isNil(eventsList) ? 0 : eventsList.size

  if (length === 0) {
    return null
  }

  const [currentEvent, setCurrentEvent] = useState(0)
  const [visibleCount, setVisibleCount] = useState(() => getVisibleCount())

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount())
    }
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const maxStart = Math.max(0, length - visibleCount)
    setCurrentEvent((prev) => Math.min(prev, maxStart))
  }, [length, visibleCount])

  const nextSlide = () => {
    setCurrentEvent((prev) => (prev === length - 1 ? 0 : prev + 1))
  }

  const prevSlide = () => {
    setCurrentEvent((prev) => (prev === 0 ? length - 1 : prev - 1))
  }

  const isActive = (index) => {
    switch (visibleCount) {
      case 1:
        return index === currentEvent
      case 2:
        return index === currentEvent || index - currentEvent === 1
      case 3:
        return index === currentEvent
          || index - currentEvent === 1
          || index - currentEvent === 2
      default:
        return false
    }
  }

  const renderRightControl = () => {
    if ((visibleCount === 1 && currentEvent === length - 1)
      || (visibleCount === 2 && currentEvent === length - 2)
      || (visibleCount === 3 && currentEvent === length - 3)
      || visibleCount > length) {
      return null
    }
    return (
      <Button
        type={TYPES.LINK}
        className="events-ama-list__control events-ama-list__control--next"
        onClick={nextSlide}
      >
        <Icon type={ICON_TYPES.CHEVRON_RIGHT} />
      </Button>
    )
  }

  const columnCount = Math.min(visibleCount, length)

  const fixEventItemWidth = () => {
    if (columnCount <= 1) return 'event-item--width-100'
    if (columnCount === 2) return 'event-item--width-50'
    return 'event-item--width-33'
  }

  const renderLeftControl = () => (
    <Button
      type={TYPES.LINK}
      className="events-ama-list__control events-ama-list__control--prev"
      onClick={prevSlide}
    >
      <Icon type={ICON_TYPES.CHEVRON_LEFT} />
    </Button>
  )

  const items = (
    <div className="events-ama-list__items">
      {eventsList && eventsList.map((eventDetail, index) => (
        <EventItem
          key={eventDetail.get('id')}
          details={eventDetail}
          language={language}
          email={email}
          isActive={isActive(index)}
          isEventsPlusMember={isEventsPlusMember}
          fixWidth={fixEventItemWidth()}
          staticText={staticText}
          renderModal={renderModal}
        />
      ))}
    </div>
  )

  return (
    <div className="events-ama-list">
      <H2 as={[HEADING_TYPES.H4_MOBILE, HEADING_TYPES.H4_DESKTOP]} className="events-ama-list__title">
        {staticText.getIn(['data', 'upcomingEvents'])}
      </H2>
      {isEventsPlusMember ? (
        <div className="events-ama-list__carousel events-ama-list__carousel--no-controls">
          <div className="events-ama-list__carousel-viewport">
            {items}
          </div>
        </div>
      ) : (
        <div className="events-ama-list__carousel">
          <div className="events-ama-list__carousel-edge events-ama-list__carousel-edge--start">
            {currentEvent !== 0
              ? renderLeftControl()
              : <span className="events-ama-list__carousel-edge-placeholder" aria-hidden="true" />}
          </div>
          <div className="events-ama-list__carousel-viewport">
            {items}
          </div>
          <div className="events-ama-list__carousel-edge events-ama-list__carousel-edge--end">
            {renderRightControl() || (
              <span className="events-ama-list__carousel-edge-placeholder" aria-hidden="true" />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default EventsAMAList
